import { mask } from './helpers';
import {
  deleteData,
  fetchData,
} from './fetch';
import toggleClassList from './toggle-class-list';

window.addEventListener('load', () => {
  const phoneInput = document.querySelectorAll('.user-phone .phone-input');
  const showTimeListButton = document.querySelectorAll('.show-time-list');
  const deliveryTimeList = document.querySelector('.delivery-time-list');
  const pickupTimeList = document.querySelector('.pickup-time-list');
  const timeLists = document.querySelectorAll('.time-list');
  const deliveryTimeInput = document.querySelector('.delivery-time-input');
  const deliveryTimeText = document.querySelector('.delivery-text');
  const pickupTimeInput = document.querySelector('.pickup-time-input');
  const pickupTimeText = document.querySelector('.pickup-text');
  const acceptDeliveryPicker = document.querySelector(
    '.accept-delivery-picker',
  );
  const acceptPickupPicker = document.querySelector('.accept-pickup-picker');
  const declineDeliveryPicker = document.querySelectorAll(
    '.decline-delivery-picker',
  );
  const declinePickupPicker = document.querySelectorAll(
    '.decline-pickup-picker',
  );
  const minSumError = document.querySelector('.min-sum-error');
  const minSumErrorSpan = document.querySelector('.min-sum-error span');
  const deliveryAddressString = document.querySelector(
    '.delivery-address span',
  );
  const deliveryAddressTitle = document.querySelector('.delivery-address div');
  const deliveryAddressWrapper = document.querySelector('.delivery-address');
  const restaurantAddressString = document.querySelector(
    '.restaurant-address.may-show span',
  );
  const restaurantWorkTime = document.querySelector(
    '.restaurant-address.may-show .work-time',
  );
  const restaurantAddressWrapper = document.querySelector(
    '.restaurant-address.may-show',
  );
  const streetIdInput = document.querySelector('.street-id');
  const houseInput = document.querySelector('.house');
  const floorInput = document.querySelector('.floor');
  const flatInput = document.querySelector('.flat');
  const restaurantIdInput = document.querySelector('.restaurant-id');
  const deliverySubmit = document.querySelector('.delivery-submit');
  const restaurantSubmit = document.querySelector('.restaurant-submit');
  const addressEntranceInput = document.querySelector('.entrance');
  const addressCommentInput = document.querySelector('.comment');
  const orderWrapper = document.querySelector('.complete-order-wrapper');
  const orderStatusIconWrapper = document.querySelector(
    '.order-status .status-icon',
  );
  const orderStatusIconImage = document.querySelector(
    '.order-status .status-icon img',
  );
  const orderStatusText = document.querySelector('.order-status .status-text');
  const deliveryTime = document.querySelector('.delivery-time-hidden');
  const pickupTime = document.querySelector('.pickup-time');
  const showPickupTimePickerBtn = document.querySelector(
    '.show-pickup-timepicker',
  );
  const showDeliveryTimePickerBtn = document.querySelector(
    '.show-delivery-timepicker',
  );
  const deliveryTimepickerWrapper = document.querySelector('.delivery-time');
  const deliveryTimepickerRow = document.querySelector('.delivery-time .row');
  const deliveryTimeHint = document.querySelector('.delivery-time-hint');
  const pickupTimepickerWrapper = document.querySelector('.pickup-time');
  const pickupTimepickerRow = document.querySelector('.pickup-time .row');
  const pickupTimeHint = document.querySelector('.pickup-time-hint');
  const cartLoader = document.querySelector('.cart-loader');
  const orderNumberString = document.querySelector('.order-number');
  const declineOrderInformation = document.querySelector(
    '.decline-order-information',
  );
  const confirmOrderInformation = document.querySelector(
    '.confirm-order-information',
  );
  const codeNumberString = document.querySelector('.code-number');
  const backButton = document.querySelector('.delivery-back-button');
  const orderDeliveryTimeInput = document.querySelector('.order-delivery-time-input');
  const deliveryNotAvailableString = document.querySelector('.delivery-not-available');
  const deliveryStartHours = document.querySelector('.delivery-start-hours');
  const pickupNotAvailableString = document.querySelector('.pickup-not-available');
  const pickupStartHours = document.querySelector('.pickup-start-hours');
  const timePopup = document.querySelector('.time-popup-wrapper');
  const timePopupTitle = document.querySelector('.time-popup-wrapper .popup-title');
  const stopListDeliveryItemsPopup = document.querySelector('.delivery-stoplist-popup-wrapper');
  const stopListPickupItemsPopup = document.querySelector('.pickup-stoplist-popup-wrapper');
  const stopListDeliveryItemsList = document.querySelector('.delivery-stoplist-popup-wrapper .stop-list-items');
  const stopListPickupItemsList = document.querySelector('.pickup-stoplist-popup-wrapper .stop-list-items');
  const stopListDeliveryItemsInputs = document.querySelectorAll('.delivery-stoplist-popup-wrapper .stop-list-items-input');
  const unableDeliveryItemsInputs = document.querySelectorAll('.unavailable-items-popup-wrapper .unavailable-delivery-items-input');
  const stopListPickupItemsInputs = document.querySelectorAll('.pickup-stoplist-popup-wrapper .stop-list-items-input');
  const stopListPickupBtn = document.querySelector('.pickup-stoplist');
  const stopListDeliveryBtn = document.querySelector('.delivery-stoplist');
  const onlyPickupProductsPopup = document.querySelector('.only-pickup-products-popup-wrapper');
  const unavailableDeliveryItems = document.querySelector('.unavailable-delivery-items');
  const unavailableItemsForm = document.querySelector('.unavailable-items-form');
  const deliveryForm = document.querySelectorAll('.order .order-form');

  const cookies = document.cookie.split(';');

  let formValues = {};
  let cartId;

  const cartIdCookie = cookies.find((cookie) => cookie.includes('cartId'));

  if (cartIdCookie) {
    cartId = cartIdCookie.split('=');
  }

  const getTimeIntervals = async (restaurantId, orderType) => {
    const response = await fetchData(`/restaurants/delivery-intervals/${restaurantId}?orderType=${orderType}&cartId=${cartId[1]}`);

    const items = response.data.map((item, index) => {
      let itemActive = false;

      if (orderType === 'delivery') {
        if (formValues.deliveryTime && formValues.deliveryTime === item) {
          itemActive = true;
        }
      } else {
        if (formValues.pickupTime && formValues.pickupTime === item) {
          itemActive = true;
        }
      }

      return `<li class="small-text ${itemActive ? 'active' : ''}">
          <input type="radio" name="time" id="time-${index}" class="time-item" value="${item}" />
        <label for="time-${index}">
          ${item}
        </label>
      </li>`;
    });

    let firstItemActive = false;

    if (orderType === 'delivery') {
      if (formValues.deliveryTime && formValues.deliveryTime === 'Как можно скорее') {
        firstItemActive = true;
      } else if (!formValues.deliveryTime) {
        firstItemActive = true;
      }
    } else {
      if (formValues.pickupTime && formValues.pickupTime === 'Как можно скорее') {
        firstItemActive = true;
      } else if (!formValues.pickupTime) {
        firstItemActive = true;
      }
    }

    const firstTimePickerItem = `<li class="small-text ${firstItemActive ? 'active' : ''}">
          <input type="radio" name="time" id="time-first" class="time-item" value="Как можно скорее" data-time="Как можно скорее" />
        <label for="time-first">
          Как можно скорее
        </label>
      </li>`;

    items.unshift(firstTimePickerItem);

    if (orderType === 'delivery' && deliveryTimeList) {
      deliveryTimeList.innerHTML = items.join('');

      if (deliverySubmit && !deliverySubmit.dataset.disabled) {
        deliverySubmit.classList.remove('disabled');
      }

      if (!formValues.deliveryTime) {
        if (deliveryTimeText) {
          deliveryTimeText.textContent = 'Как можно скорее';
        }

        if (deliveryTime) {
          deliveryTime.value = 'Как можно скорее';
        }

        formValues.currentDeliveryTime = 'Как можно скорее';

        if (sessionStorage) {
          sessionStorage.setItem(
            'formValues',
            JSON.stringify(formValues),
          );
        }
      }

      if (!response.data.length && deliveryNotAvailableString && deliverySubmit && deliveryTimepickerRow && deliveryStartHours) {
        deliveryNotAvailableString.classList.add('visible');
        deliveryStartHours.textContent = formValues.restaurantWorkingHoursStart;
        deliverySubmit.classList.add('disabled');
        deliverySubmit.dataset.notavailable = 'true';
        deliveryTimepickerRow.classList.add('disabled');
        deliveryTimepickerRow.dataset.notavailable = 'true'
      }
    } else if (orderType === 'delivery-togo' && pickupTimeList) {
      pickupTimeList.innerHTML = items.join('');

      if (restaurantSubmit) {
        restaurantSubmit.classList.remove('disabled');
      }

      if (!formValues.pickupTime) {
        if (pickupTimeText) {
          pickupTimeText.textContent = 'Как можно скорее';
        }

        if (pickupTime) {
          pickupTime.value = 'Как можно скорее';
        }

        formValues.currentPickupTime = 'Как можно скорее';

        if (sessionStorage) {
          sessionStorage.setItem(
            'formValues',
            JSON.stringify(formValues),
          );
        }
      }

      if (!response.data.length && pickupNotAvailableString && restaurantSubmit && pickupTimepickerRow && pickupStartHours) {
        pickupNotAvailableString.classList.add('visible');
        pickupStartHours.textContent = formValues.pickupStartHours;
        restaurantSubmit.classList.add('disabled');
        restaurantSubmit.dataset.notavailable = 'true';
        pickupTimepickerRow.classList.add('disabled');
        pickupTimepickerRow.dataset.notavailable = 'true'
      }
    }

    if (timeLists) {
      [].forEach.call(timeLists, (list) => {
        list.addEventListener('click', (e) => {
          if (e.target.classList.contains('time-item')) {
            const parentElement = e.target.closest('.time-wrapper');
            const listLi = e.target.closest('li');
            const { value } = e.target;

            if (parentElement) {
              const activeTime = parentElement.querySelector('.active-time span');
              const timelistOverlay = parentElement.querySelector(
                '.time-list-overlay',
              );
              const timelistItem = parentElement.querySelector('.time-list');

              if (activeTime) {
                if (value === 'Как можно скорее') {
                  activeTime.dataset.time = e.target.dataset.time;
                }

                activeTime.textContent = value;
              }

              if (timelistOverlay) {
                timelistOverlay.classList.remove('visible');
              }

              if (timelistItem) {
                timelistItem.classList.remove('visible');
                const listItems = timelistItem.querySelectorAll('li');

                [].forEach.call(listItems, (item) =>
                  item.classList.remove('active'),
                );
              }
            }

            if (listLi) {
              listLi.classList.add('active');
            }

            if (window.innerWidth < 895) {
              if (orderType === 'delivery') {
                const parentElement = document.querySelector(
                  '.timepicker-popup-wrapper.delivery',
                );

                if (parentElement) {
                  const activeTime = parentElement.querySelector(
                    '.active-time span',
                  );

                  if (deliveryTimeInput) {
                    deliveryTimeInput.value = activeTime.innerHTML;
                    deliveryTime.value = activeTime.innerHTML;
                  }

                  if (deliveryTimeText) {
                    if (value === 'Как можно скорее') {
                      deliveryTimeText.textContent = 'Как можно скорее';
                      formValues.currentDeliveryTime = 'Как можно скорее';
                      deliveryTime.value = e.target.dataset.time;
                    } else {
                      deliveryTimeText.textContent = value;
                      formValues.deliveryTime = value;
                      formValues.currentDeliveryTime = value;
                      deliveryTime.value = value;
                    }

                    activeTime.innerHTM = value;
                    parentElement.classList.remove('active');

                    if (sessionStorage) {
                      sessionStorage.setItem(
                        'formValues',
                        JSON.stringify(formValues),
                      );
                    }
                  }
                }
              } else {
                const parentElement = document.querySelector(
                  '.timepicker-popup-wrapper.pickup',
                );

                if (parentElement) {
                  const activeTime = parentElement.querySelector(
                    '.active-time span',
                  );

                  if (pickupTimeInput) {
                    pickupTimeInput.value = activeTime.innerHTML;
                    pickupTime.value = activeTime.innerHTML;
                  }

                  if (pickupTimeText) {
                    if (value === 'Как можно скорее') {
                      pickupTimeText.textContent = 'Как можно скорее';
                      formValues.currentPickupTime = 'Как можно скорее';
                      pickupTime.value = e.target.dataset.time;
                    } else {
                      formValues.pickupTime = value;
                      pickupTime.value = value;
                      formValues.currentPickupTime = value;
                      pickupTimeText.textContent = value;
                    }

                    activeTime.innerHTM = value;
                    parentElement.classList.remove('active');

                    if (sessionStorage) {
                      sessionStorage.setItem(
                        'formValues',
                        JSON.stringify(formValues),
                      );
                    }
                  }
                }
              }
            }
          }
        });
      });
    }
  }

  const formValuesFromSessionStorage = sessionStorage ? sessionStorage.getItem('formValues') : null;

  if (formValuesFromSessionStorage) {
    formValues = JSON.parse(formValuesFromSessionStorage);
  }

  const getStopList = async (restaurantId, type) => {
    const response = await fetchData(`/order/stop-list?organizationId=${restaurantId}`);

    if (response.stopListItems && response.stopListItems.length) {
      const stopListProducts = [];

      response.stopListItems.forEach((i) => {
        if (response.cartItems.find((p) => p.productId === i)) {
          stopListProducts.push(response.cartItems.find((p) => p.productId === i));
        }
      });

      if (stopListProducts.length) {
        const items = stopListProducts.map((item) => (
          `<div class="stoplist-item">
            ${item.parent ? `<span class="bold base-text">${item.parent.name}, </span>` : ''}
            <span class="base-text ${item.parent ? 'italic' : 'bold'}">${item.name}</span>
          </div>`
        ));

        if (deliverySubmit && type === 'delivery') {
          deliverySubmit.style.display = 'none';

          if (stopListDeliveryItemsPopup) {
            stopListDeliveryItemsPopup.classList.add('active');
          }

          if (stopListDeliveryItemsList) {
            stopListDeliveryItemsList.innerHTML = items.join('');
          }

          if (stopListDeliveryBtn) {
            stopListDeliveryBtn.classList.add('active');
          }

          if (stopListDeliveryItemsInputs) {
            [].forEach.call(stopListDeliveryItemsInputs, (input) => {
              input.value = stopListProducts.map((i) => i.id);
            });
          }
        }

        if (restaurantSubmit && type === 'delivery-togo') {
          restaurantSubmit.style.display = 'none';

          if (stopListPickupItemsPopup) {
            stopListPickupItemsPopup.classList.add('active');
          }

          if (stopListPickupItemsList) {
            stopListPickupItemsList.innerHTML = items.join('');
          }

          if (stopListPickupBtn) {
            stopListPickupBtn.classList.add('active');
          }

          if (stopListPickupItemsInputs) {
            [].forEach.call(stopListPickupItemsInputs, (input) => {
              input.value = stopListProducts.map((i) => i.id);
            });
          }
        }
      }
    }
  }

  if (formValues && Object.keys(formValues).length) {
    setInterval(() => {
      if (formValues.deliveryOrganizationId && deliveryTimeList) {
        getTimeIntervals(formValues.deliveryOrganizationId, 'delivery');
      }

      if (formValues.pickupOrganizationId && pickupTimeList) {
        getTimeIntervals(formValues.pickupOrganizationId, 'delivery-togo');
      }
    }, 5 * 60 * 1000);

    if (formValues.deliveryOrganizationId && deliveryTimeList) {
      getTimeIntervals(formValues.deliveryOrganizationId, 'delivery');
    }

    if (formValues.pickupOrganizationId && pickupTimeList) {
      getTimeIntervals(formValues.pickupOrganizationId, 'delivery-togo');
    }

    if (formValues.deliveryOrganizationId) {
      getStopList(formValues.deliveryOrganizationId, 'delivery');
    }

    if (formValues.pickupOrganizationId) {
      getStopList(formValues.pickupOrganizationId, 'delivery-togo');
    }

    if (formValues.street && formValues.house) {
      let deliveryAddress = `${formValues.street}, ${formValues.house}`;

      if (deliveryTimeHint) {
        deliveryTimeHint.classList.add('hidden');
      }

      if (
        showDeliveryTimePickerBtn &&
        !showDeliveryTimePickerBtn.dataset.deliverystart &&
        !showDeliveryTimePickerBtn.dataset.deliveryend
      ) {
        if (deliveryTimepickerWrapper) {
          deliveryTimepickerWrapper.classList.add('disabled');
        }

        const getDeliveryAvailability = async () => {
          const response = await fetchData(`/order/delivery-availability?address=${deliveryAddress}&streetKladrId=${formValues.streetId}`);

          if (response) {
            formValues.restaurantWorkingHoursStart = response.data.organizationDeliveryHoursStart;

            if (deliveryTimepickerWrapper) {
              deliveryTimepickerWrapper.classList.remove('disabled');
            }

            if (deliveryTimepickerRow && !deliveryTimepickerRow.dataset.notavailable) {
              deliveryTimepickerRow.classList.remove('disabled')
            }

            // if (minSumError) {
            //   const total = minSumError.dataset.total;
            //   if (response.data.deliveryFreeTotal > parseFloat(total)) {
            //     minSumError.classList.add('visible');
            //
            //     if (minSumErrorSpan) {
            //       minSumErrorSpan.textContent =
            //         response.data.deliveryFreeTotal / 100;
            //     }
            //
            //     if (deliverySubmit) {
            //       deliverySubmit.classList.add('disabled');
            //     }
            //
            //     if (backButton) {
            //       backButton.setAttribute(
            //         'href',
            //         '/cart?deliveryFreeTotal=' +
            //           response.data.deliveryFreeTotal +
            //           '',
            //       );
            //     }
            //   } else {
            //     deliverySubmit.removeAttribute('data-disabled');
            //
            //     if (!deliverySubmit.dataset.notavailable) {
            //       deliverySubmit.classList.remove('disabled');
            //     }
            //   }
            // }

            if (sessionStorage) {
              sessionStorage.setItem('formValues', JSON.stringify(formValues));
            }
          }
        }

        getDeliveryAvailability();
      }

      if (streetIdInput) {
        streetIdInput.value = formValues.streetId;
      }

      if (houseInput) {
        houseInput.value = formValues.house;
      }

      if (formValues.flat) {
        deliveryAddress = `${deliveryAddress}, кв. ${formValues.flat}`;

        if (flatInput) {
          flatInput.value = formValues.flat;
        }
      }

      if (formValues.floor) {
        deliveryAddress = `${deliveryAddress}, эт. ${formValues.floor}`;

        if (floorInput) {
          floorInput.value = formValues.floor;
        }
      }

      if (formValues.entrance && addressEntranceInput) {
        deliveryAddress = `${deliveryAddress}, под. ${formValues.entrance}`;

        addressEntranceInput.value = formValues.entrance;
      }

      if (formValues.comment && addressCommentInput) {
        addressCommentInput.value = formValues.comment;
      }

      if (deliveryAddressWrapper) {
        deliveryAddressWrapper.classList.add('base-text');
        deliveryAddressWrapper.classList.add('with-address');
        deliveryAddressWrapper.classList.remove('very-small-text');
      }

      if (deliveryAddressString) {
        deliveryAddressString.textContent = deliveryAddress;
      }

      if (formValues.title && deliveryAddressTitle) {
        deliveryAddressTitle.textContent = formValues.title;
      }
    }

    if (formValues.restaurantAddress && restaurantAddressString) {
      if (pickupTimeHint) {
        pickupTimeHint.classList.add('hidden');
      }

      restaurantAddressString.textContent = formValues.restaurantAddress;

      if (restaurantIdInput && formValues.organizationId) {
        restaurantIdInput.value = formValues.organizationId;

        if (
          showPickupTimePickerBtn &&
          !showPickupTimePickerBtn.dataset.pickupstart &&
          !showPickupTimePickerBtn.dataset.pickupend
        ) {
          if (pickupTimepickerWrapper) {
            pickupTimepickerWrapper.classList.add('disabled');
          }

          const getRestaurant = async () => {
            const response = await fetchData(`/restaurants/${restaurantIdInput.value}`);

            if (response) {
              if (pickupTimepickerWrapper) {
                pickupTimepickerWrapper.classList.remove('disabled');
              }

              if (pickupTimepickerRow && !pickupTimepickerRow.dataset.notavailable) {
                pickupTimepickerRow.classList.remove('disabled');
              }

              if (restaurantSubmit && !restaurantSubmit.dataset.notavailable) {
                restaurantSubmit.classList.remove('disabled');
              }
            }
          };

          getRestaurant();
        }
      }

      if (restaurantAddressWrapper) {
        restaurantAddressWrapper.classList.add('base-text');
        restaurantAddressWrapper.classList.add('with-address');
        restaurantAddressWrapper.classList.remove('very-small-text');
      }
    }

    if (formValues.workTime && restaurantWorkTime) {
      restaurantWorkTime.textContent = `Время работы: ${formValues.workTime}`;
    }

    if (formValues.deliveryTime && deliveryTimeText && deliveryTimeInput) {
      if (
        !formValues.currentDeliveryTime ||
        formValues.currentDeliveryTime === 'Как можно скорее'
      ) {
        deliveryTimeText.textContent = 'Как можно скорее';
      } else {
        deliveryTimeText.textContent = formValues.deliveryTime;
      }

      deliveryTimeInput.value = formValues.deliveryTime;
      deliveryTime.value = formValues.deliveryTime;
    }

    if (formValues.pickupTime && pickupTimeText && pickupTimeInput) {
      if (
        !formValues.currentPickupTime ||
        formValues.currentPickupTime === 'Как можно скорее'
      ) {
        pickupTimeText.textContent = 'Как можно скорее';
      } else {
        pickupTimeText.textContent = formValues.pickupTime;
      }

      pickupTimeInput.value = formValues.pickupTime;
      pickupTime.value = formValues.pickupTime;
    }
  }

  if (phoneInput) {
    [].forEach.call(phoneInput, (input) => {
      if (input.value.length) {
        mask(input, '+_ ___ ___ __ __');
      }
    });
  }

  if (acceptDeliveryPicker) {
    acceptDeliveryPicker.addEventListener('click', () => {
      const parentElement = acceptDeliveryPicker.closest(
        '.timepicker-popup-wrapper',
      );

      if (parentElement) {
        const activeTime = parentElement.querySelector('.active-time span');

        if (deliveryTimeInput) {
          deliveryTimeInput.value = activeTime.innerHTML;
          deliveryTime.value = activeTime.innerHTML;
        }

        if (deliveryTimeText) {
          if (activeTime.textContent === 'Как можно скорее') {
            deliveryTimeText.textContent = 'Как можно скорее';
            formValues.currentDeliveryTime = 'Как можно скорее';
            deliveryTime.value = activeTime.dataset.time;
          } else {
            deliveryTimeText.textContent = activeTime.innerHTML;
            formValues.deliveryTime = activeTime.innerHTML;
            formValues.currentDeliveryTime = activeTime.innerHTML;
            deliveryTime.value = activeTime.innerHTML;
          }

          if (sessionStorage) {
            sessionStorage.setItem('formValues', JSON.stringify(formValues));
          }
        }
      }
    });
  }

  if (acceptPickupPicker) {
    acceptPickupPicker.addEventListener('click', () => {
      const parentElement = acceptPickupPicker.closest(
        '.timepicker-popup-wrapper',
      );

      if (parentElement) {
        const activeTime = parentElement.querySelector('.active-time span');

        if (pickupTimeInput) {
          pickupTimeInput.value = activeTime.innerHTML;
          pickupTime.value = activeTime.innerHTML;
        }

        if (pickupTimeText) {
          if (activeTime.textContent === 'Как можно скорее') {
            pickupTimeText.textContent = 'Как можно скорее';
            formValues.currentPickupTime = 'Как можно скорее';
            pickupTime.value = activeTime.dataset.time;
          } else {
            formValues.pickupTime = activeTime.innerHTML;
            pickupTime.value = activeTime.innerHTML;
            formValues.currentPickupTime = activeTime.innerHTML;
            pickupTimeText.textContent = activeTime.innerHTML;
          }

          if (sessionStorage) {
            sessionStorage.setItem('formValues', JSON.stringify(formValues));
          }
        }
      }
    });
  }

  if (declineDeliveryPicker) {
    [].forEach.call(declineDeliveryPicker, (btn) => {
      btn.addEventListener('click', () => {
        const parentElement = btn.closest('.timepicker-popup-wrapper');

        if (parentElement) {
          const activeTime = parentElement.querySelector('.active-time span');

          if (activeTime) {
            activeTime.textContent = 'Как можно скорее';
          }
        }
      });
    });
  }

  if (declinePickupPicker) {
    [].forEach.call(declinePickupPicker, (btn) => {
      btn.addEventListener('click', () => {
        const parentElement = btn.closest('.timepicker-popup-wrapper');

        if (parentElement) {
          const activeTime = parentElement.querySelector('.active-time span');

          if (activeTime) {
            activeTime.textContent = 'Как можно скорее';
          }
        }
      });
    });
  }

  if (showTimeListButton) {
    [].forEach.call(showTimeListButton, (button) => {
      button.addEventListener('click', () => {
        const parentElement = button.closest('.time-wrapper');

        if (parentElement) {
          const timeList = parentElement.querySelector('.time-list');
          const timeListOverlay = parentElement.querySelector(
            '.time-list-overlay',
          );

          if (timeList) {
            timeList.classList.add('visible');
          }

          if (timeListOverlay) {
            timeListOverlay.classList.add('visible');

            timeListOverlay.addEventListener('click', () => {
              timeListOverlay.classList.remove('visible');

              if (timeList) {
                timeList.classList.remove('visible');
              }
            });
          }
        }
      });
    });
  }

  const deleteItemCart = async (productId) => {
    const cartId = document.cookie.split(';')?.find((cookie) =>
      cookie.includes('cartId'),
    )?.split('=')?.[1]

    return await deleteData(`/carts/${cartId}/${productId}`, new URLSearchParams({type: 'portal'}));
  }

  unavailableItemsForm?.addEventListener("submit", async (e) => {
    e.preventDefault()
    const cartItemsToDelete = e.target[0].value.split(',')

    cartLoader.classList.add('visible');

    for (let i = 0; i < cartItemsToDelete.length; i++) {
      await deleteItemCart(cartItemsToDelete[i])
    }

    window.location.reload();
  })

  if (deliverySubmit) {
    deliverySubmit.addEventListener('click', () => {
      deliverySubmit.classList.add('disabled');
    });
  }

  if (deliveryForm) {
    const handler = () => {
      const formValues = sessionStorage ? sessionStorage.getItem('formValues') : null;
      const parsedFormValues = formValues ? JSON.parse(formValues) : null;
      const deletedFields = ['orderId', 'amount'];

      if (!parsedFormValues) return;

      deletedFields.forEach((item) => {
        typeof parsedFormValues[item] !== undefined && delete parsedFormValues[item];
      });

      sessionStorage.setItem('formValues', JSON.stringify(parsedFormValues));
    };

    [].forEach.call(deliveryForm, (form) => {
      form.addEventListener('submit', handler);
    });

    window.addEventListener('unload', () => {
      [].forEach.call(deliveryForm, (form) => {
        form.removeEventListener('submit', handler)
      });
    });
  }

  if (restaurantSubmit) {
    restaurantSubmit.addEventListener('click', () => {
      restaurantSubmit.classList.add('disabled');
    });
  }

  if (orderWrapper) {
    const orderId = orderWrapper.dataset.id;

    const formValuesFromSessionStorage = sessionStorage ? sessionStorage.getItem('formValues') : null;

    if (formValuesFromSessionStorage) {
      sessionStorage.removeItem('formValues');
    }

    const orderChangesFromSessionStorage = sessionStorage ? sessionStorage.getItem('orderChanges') : null;

    if (orderChangesFromSessionStorage) {
      const orderChanges = JSON.parse(orderChangesFromSessionStorage);

      if (orderChanges.deliveryTime) {
        timePopup.classList.add('active');

        const pickupTimeArray = orderChanges.deliveryTime.split(':');
        let time = new Date();
        time.setHours(pickupTimeArray[0]);
        time.setMinutes(pickupTimeArray[1]);

        if (timePopupTitle) {
          if (orderChanges.type === 'delivery') {
            timePopupTitle.textContent = `Мы доставим ваш заказ к ${orderChanges.deliveryTime}`
          }

          if (orderChanges.type === 'delivery-togo') {
            timePopupTitle.textContent = `Мы приготовим Ваш заказ к ${orderChanges.deliveryTime}`
          }
        }
      }

      sessionStorage.removeItem('orderChanges');
    }

    const statuses = {
      delivery: {
        'accepted': 'Ожидает подтверждение',
        'delivered': 'Доставлен',
        'confirmed': 'Подтвержден',
        'preparing': 'Готовится',
        'cancelled': 'Отменен',
        'closed': 'Закрыт',
        'onw': 'Заказ в пути',
        'processing': 'Заказ в обработке',
        'payment-await': 'Заказ в обработке',
        'cook-done': 'Собираем заказ'
      },
      'delivery-togo': {
        'accepted': 'Ожидает подтверждение',
        'delivered': 'Доставлен',
        'confirmed': 'Подтвержден',
        'preparing': 'Готовится',
        'cancelled': 'Отменен',
        'closed': 'Закрыт',
        'onw': 'Заберите заказ',
        'processing': 'Заказ в обработке',
        'payment-await': 'Заказ в обработке',
        'cook-done': 'Собираем заказ'
      },
      cafe: {
        'accepted': 'Ожидает подтверждение',
        'delivered': 'Доставлен',
        'confirmed': 'Подтвержден',
        'preparing': 'Готовится',
        'cancelled': 'Отменен',
        'closed': 'Закрыт',
        'onw': 'Заберите заказ',
        'processing': 'Заказ в обработке',
        'payment-await': 'Заказ в обработке',
        'cook-done': 'Собираем заказ'
      }
    };

    const icons = {
      accepted: window.acceptedIcon,
      confirmed: window.confirmedIcon,
      preparing: window.preparingIcon,
      onw: window.onwIcon,
      cancelled: window.cancelledIcon,
      processing: window.processingIcon,
      'payment-await': window.paymentAwaitIcon,
      'cook-done': window.cookDoneIcon,
    };

    const updateOrder = () => {
      let orderTimeout;

      orderTimeout = setTimeout(async () => {
        const response = await fetchData(`/profile/orders/${orderId}`);

        if (response) {
          let orderDeliveryTimeValue;
          const {
            status: orderStatus,
            refunded: orderRefunded,
            code: orderCode,
            deliveryDateTime: orderDeliveryDateTime,
            number: orderNumber,
            orderType: responseOrderType,
          } = response;

          if (orderDeliveryTimeInput) {
            orderDeliveryTimeValue = orderDeliveryTimeInput.value;
          }

          if (orderDeliveryTimeValue !== orderDeliveryDateTime) {
            orderDeliveryTimeInput.value = orderDeliveryDateTime;
          }

          if (orderStatusIconWrapper) {
            if (orderStatus === 'closed' || orderStatus === 'delivered') {
              orderStatusIconWrapper.classList.add('hidden');
            } else {
              if (orderStatusIconWrapper.classList.contains('hidden')) {
                orderStatusIconWrapper.classList.remove('hidden');
              }
            }
          }

          if (orderStatusIconImage) {
            if (orderStatus === 'closed' || orderStatus === 'delivered') {
              orderStatusIconImage.remove();
            } else {
              orderStatusIconImage.setAttribute('src', icons[orderStatus]);
              orderStatusIconImage.setAttribute('alt', statuses[responseOrderType][orderStatus]);

              if (orderStatus !== 'processing' && orderStatus !== 'payment-await') {
                orderStatusIconImage.classList.remove('animate');
              }
            }
          }

          if (orderStatusText) {
            orderStatusText.textContent = statuses[responseOrderType][orderStatus];
          }

          if (orderNumber && orderNumberString) {
            orderNumberString.textContent = `Заказ №${orderNumber}`;
          }

          toggleClassList({
            element: declineOrderInformation,
            isAdd: orderStatus === 'cancelled' && orderRefunded,
          });

          toggleClassList({
            element: confirmOrderInformation,
            isAdd: orderStatus !== 'cancelled',
          });

          if (orderStatus !== 'cancelled' && confirmOrderInformation) {
            const confirmOrderInformationBottom = confirmOrderInformation.querySelector(
              '.pickup-order-information-bottom'
            );
            const isVisibleConfirmOrderInformationBottom = !!(responseOrderType === 'delivery-togo'
              && orderCode
              && codeNumberString);

            toggleClassList({
              element: confirmOrderInformationBottom,
              isAdd: isVisibleConfirmOrderInformationBottom,
            });

            if (isVisibleConfirmOrderInformationBottom) {
              codeNumberString.textContent = orderCode;
            }
          }

          clearTimeout(orderTimeout);
          updateOrder();
        } else {
          clearTimeout(orderTimeout);
          updateOrder();
        }
      }, 30000);
    };

    updateOrder();
  }
});
